import container from "../../libs/container/container";


const amdHomeAboutModule = (function () {
    const name = 'home__about-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    };


    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeAboutInfoHeaderAreaCls, 'animate__fadeInLeft25P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeAboutBtnReadMoreCls, 'animate__fadeInUp50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeAboutInfoTextContentCls, 'animate__fadeInRight25P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHomeAboutModule;